/**
 * The two kinds of on-page anchor a tour step or a help-assistant hint can
 * point at (D10 WP8a, #3630):
 *
 *  - `data-tour="contacts-new"` -- a guided-tour anchor (no dot);
 *  - `data-help="crm-settings.save-profile"` -- a help anchor,
 *    `<page-key>.<control>`, added to every primary control so the assistant
 *    can point at it. The page key is the page guide's key, so two pages never
 *    share an anchor.
 *
 * The dot tells them apart, so one `target` string selects either.
 */

/** A tour anchor id (the server's `sanitize.ID_RE`). */
export const TOUR_ANCHOR_RE = /^[a-z0-9_-]{1,64}$/;

/** A help anchor id (the server's `page_guides.HELP_ANCHOR_RE`, 64 chars max). */
export const HELP_ANCHOR_RE = /^(?=.{1,64}$)[a-z0-9]+(?:-[a-z0-9]+)*\.[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function isHelpAnchor(target: string): boolean {
  return HELP_ANCHOR_RE.test(target);
}

/** True for either kind of anchor id. */
export function isAnchorId(target: string): boolean {
  return TOUR_ANCHOR_RE.test(target) || HELP_ANCHOR_RE.test(target);
}

/** The CSS selector for a step or hint target (`data-help` or `data-tour`). */
export function anchorSelector(target: string): string {
  return isHelpAnchor(target) ? `[data-help="${target}"]` : `[data-tour="${target}"]`;
}
